require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./svgicon"), require("./flyout"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./svgicon", "./flyout"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./svgicon"), require("./flyout")) : factory(root["./utils"], root["./svgicon"], root["./flyout"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__13__, __WEBPACK_EXTERNAL_MODULE__28__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[31],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__13__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 28:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__28__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(312);


/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _IconPicker = _interopRequireDefault(__webpack_require__(313));

exports["default"] = _IconPicker["default"];
exports.IconPicker = _IconPicker["default"];

/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _flyout = _interopRequireDefault(__webpack_require__(28));

var _svgicon = _interopRequireDefault(__webpack_require__(13));

var _baUiCarbon = __webpack_require__(12);

var _utils = __webpack_require__(4);

var _IconPicker = _interopRequireDefault(__webpack_require__(314));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: @ba/ba-ui-carbon-toolkit
 * (C) Copyright IBM Corp. 2020, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var iconpickerClassName = _IconPicker["default"].iconpickerClassName.replace(/"/g, '');

var sanitize = _utils.propsUtils.sanitize;
var uniqueId = _utils.lodash.uniqueId;

var IconPicker = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(IconPicker, _Component);

  function IconPicker(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      open: false
    };
    _this._handleOpen = _this._handleOpen.bind((0, _assertThisInitialized2["default"])(_this));
    _this._handleSelect = _this._handleSelect.bind((0, _assertThisInitialized2["default"])(_this));
    _this._handleKey = _this._handleKey.bind((0, _assertThisInitialized2["default"])(_this));
    _this._id = uniqueId('ba-common-icon-picker__');
    _this.attachRef = _react["default"].createRef();
    return _this;
  }

  var _proto = IconPicker.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var open = this.state.open;
    var _this$props = this.props,
        className = _this$props.className,
        disabled = _this$props.disabled,
        icons = _this$props.icons,
        selectedIcon = _this$props.selectedIcon,
        style = _this$props.style,
        buttonExtraOptions = _this$props.buttonExtraOptions,
        flyoutExtraOptions = _this$props.flyoutExtraOptions,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["className", "disabled", "icons", "selectedIcon", "style", "buttonExtraOptions", "flyoutExtraOptions"]);
    var orientation = this.props.orientation;

    if (typeof orientation === 'undefined') {
      orientation = document.body.dir === 'rtl' ? 'bottomLeft' : 'bottomRight';
    }

    var classNames = "" + iconpickerClassName + (className.length > 0 ? " " + className : '') + (selectedIcon.icon.id === '' ? " " + iconpickerClassName + "__none" : '');
    return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, sanitize(others, IconPicker), {
      className: classNames,
      ref: this.attachRef,
      style: style
    }), /*#__PURE__*/_react["default"].createElement(_svgicon["default"], (0, _extends2["default"])({
      tabIndex: 0,
      "data-tid": "ba-common-icon-picker__button",
      disabled: disabled,
      className: iconpickerClassName + "__svgIcon",
      iconId: selectedIcon.icon.id,
      onClick: !disabled ? this._handleOpen.bind(this) : undefined,
      onKeyDown: !disabled ? function (e) {
        return _this2._handleOpenOnKeydown(e);
      } : undefined
    }, buttonExtraOptions)), open && /*#__PURE__*/_react["default"].createElement(_flyout["default"], (0, _extends2["default"])({
      id: this._id + "-flyout",
      "data-tid": "ba-common-icon-picker__flyout"
    }, flyoutExtraOptions, {
      "aria-hidden": open,
      placement: orientation,
      domNodeToAttachTo: this.attachRef.current,
      hideArrow: true,
      offset: 2,
      onClose: this._handleOpen.bind(this),
      className: iconpickerClassName + "__flyout"
    }), icons.map(this._displayIcon.bind(this))));
  };

  _proto._handleOpen = function _handleOpen() {
    this.setState({
      open: !this.state.open
    });
  };

  _proto._handleOpenOnKeydown = function _handleOpenOnKeydown(e) {
    // 13 = Return, 32 = Space
    if (e.keyCode === 13 || e.keyCode === 32) {
      e.preventDefault();

      this._handleOpen();
    }
  };

  _proto._handleSelect = function _handleSelect(iconSpec) {
    this.props.onIconSelected(iconSpec); // close the flyout after selection

    this.setState({
      open: !this.state.open
    });
  };

  _proto._handleKey = function _handleKey(e, iconSpec) {
    // 13 = Return, 32 = Space
    if (e.keyCode === 13 || e.keyCode === 32) {
      this._handleSelect(iconSpec); // Prevent browser's default action: space does a PageDown


      e.preventDefault();
    }
  };

  _proto._displayIcon = function _displayIcon(iconSpec, index) {
    var _this3 = this;

    if (iconSpec === void 0) {
      iconSpec = {};
    }

    var iconExtraOptions = this.props.iconExtraOptions;
    var className = iconExtraOptions.className,
        size = iconExtraOptions.size,
        tabIndex = iconExtraOptions.tabIndex,
        verticalAlign = iconExtraOptions.verticalAlign,
        others = (0, _objectWithoutPropertiesLoose2["default"])(iconExtraOptions, ["className", "size", "tabIndex", "verticalAlign"]);
    var _iconSpec = iconSpec,
        icon = _iconSpec.icon;
    var displayGhostButton = icon.id === 'none';
    var classnames = (0, _utils.classnames)(displayGhostButton ? iconpickerClassName + "__text" : iconpickerClassName + "__cell", "" + className);
    return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
      key: index,
      tabIndex: tabIndex,
      className: classnames,
      onClick: function onClick() {
        return _this3._handleSelect(iconSpec);
      },
      onKeyDown: function onKeyDown(e) {
        return _this3._handleKey(e, iconSpec);
      },
      title: iconSpec.label
    }, sanitize(others, IconPicker)), displayGhostButton ? /*#__PURE__*/_react["default"].createElement(_baUiCarbon.Button, {
      kind: "ghost",
      size: "small",
      tabIndex: tabIndex,
      className: iconpickerClassName + "__ghost",
      onClick: function onClick() {
        return _this3._handleSelect(iconSpec);
      },
      onKeyDown: function onKeyDown(e) {
        return _this3._handleKey(e, iconSpec);
      }
    }, iconSpec.label) : /*#__PURE__*/_react["default"].createElement(_svgicon["default"], {
      iconId: icon.id,
      alt: iconSpec.label,
      ariaLabelledby: uniqueId('icon-picker-svg'),
      size: size,
      verticalAlign: verticalAlign
    }));
  };

  return IconPicker;
}(_react.Component);

exports["default"] = IconPicker;
(0, _defineProperty2["default"])(IconPicker, "propTypes", {
  /** Custom class name(s) */
  className: _propTypes["default"].string,

  /** Flag to disable the icon picker */
  disabled: _propTypes["default"].bool,

  /** Icons to be selected */
  icons: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    icon: _propTypes["default"].shape({
      id: _propTypes["default"].string.isRequired
    }).isRequired,
    iconId: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string.isRequired
  })).isRequired,

  /** Flyout.propTypes.placement */
  orientation: _flyout["default"].propTypes.placement,

  /** Function that will get called on click of a icon */
  onIconSelected: _propTypes["default"].func.isRequired,

  /** Selected icon to show */
  selectedIcon: _propTypes["default"].shape({
    icon: _propTypes["default"].shape({
      id: _propTypes["default"].string.isRequired
    }).isRequired,
    iconId: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string.isRequired
  }).isRequired,

  /** Custom css styles */
  style: _propTypes["default"].object,

  /** Extra options for the svg click to open/close the flyout */
  buttonExtraOptions: _propTypes["default"].object,

  /** Extra options for the svg to pass to Flyout */
  iconExtraOptions: _propTypes["default"].shape({
    className: _propTypes["default"].string,
    size: _propTypes["default"].string,
    tabIndex: _propTypes["default"].number,
    verticalAlign: _propTypes["default"].string
  }),

  /** Extra options to pass to Flyout */
  flyoutExtraOptions: _propTypes["default"].object
});
(0, _defineProperty2["default"])(IconPicker, "defaultProps", {
  disabled: false,
  className: '',
  style: {},
  buttonExtraOptions: {},
  iconExtraOptions: {
    tabIndex: 0,
    className: '',
    verticalAlign: 'inherit'
  },
  flyoutExtraOptions: {}
});

/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(315);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-iconpicker{position:relative;display:flex;height:24px;width:24px;font-size:.875rem;background-color:#fff;background-color:hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1)}.ba-common-iconpicker .ba-common-iconpicker__svgIcon{margin:auto}.ba-common-iconpicker__none{background-image:repeating-linear-gradient(135deg, #fff 0%, #fff 48%, red 50%, #fff 52%, #fff 100%);background-repeat:no-repeat}.ba-common-iconpicker__flyout{padding:0.3em;width:200px;flex-wrap:wrap;display:flex;justify-content:flex-start;-ms-high-contrast-adjust:none}.ba-common-iconpicker__cell{display:inline-block;width:16px;height:16px;margin:8px}.ba-common-iconpicker__cell:hover{cursor:pointer}.ba-common-iconpicker__text{width:100%;height:100%;text-align:center}.ba-common-iconpicker__text:hover{cursor:pointer}.ba-common-iconpicker .ba-common-iconpicker__ghost{width:100%;height:100%;display:flex;justify-content:center;color:#161616;color:hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1)}.ba-common-iconpicker .ba-common-iconpicker__ghost:hover{background-color:#fff;background-color:hsla(var(--icon-03-h, 0), var(--icon-03-s, 0%), var(--icon-03-l, 100%), 1);color:#161616;color:hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1)}\n", ""]);

// exports
exports.locals = {
	"iconpickerClassName": "\"ba-common-iconpicker\""
};

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[311,0]]]);
});